import script from "./statistics.vue?vue&type=script&setup=true&lang=js"
export * from "./statistics.vue?vue&type=script&setup=true&lang=js"

import "./statistics.vue?vue&type=style&index=0&id=4fa26b82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fa26b82"]])

export default __exports__